import React, { useState, useContext, useEffect } from 'react';
import axios from "axios";
import { TextField , Button, Tooltip, Grid, Box, styled } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { jaJP } from '@mui/x-date-pickers';
import { Authentication } from '../../App'
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Modal } from '@mui/material';
import VideocamIcon from '@mui/icons-material/Videocam';
import moment from 'moment-timezone';
import { useLocation } from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Tokyo");

const EditButton = ({ onClick }) => {
  return (
    <IconButton onClick={onClick}>
      <EditIcon/>
    </IconButton>
  );
};

const VideoCall = ({ onClick }) => {
    return (
      <IconButton onClick={onClick}>
        <VideocamIcon/>
      </IconButton>
    );
  };

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
function ReservationCall(props) {
    
  
  const { children, value, index, ...other } = props;
  const [reservation_at, setReservation_at] = useState(null);//
  const [limited_at, setLimited_at] = useState(null);//
  const [start_at, setStart_at] = useState(null);//
  const [uuid, setUuid] = useState("");///
  const [tooltipOpen,setTooltipOpen] = useState(false);//
  const [topic,setTopic] = useState('');//
  const [id,setId] = useState(0);//
  const [open, setOpen] = useState(false);
  const [connect, setConnect] = useState(false);
  const [createdOpen,setCreatedOpen] = useState(false);
  const [connectOpen, setconnectOpen] = useState(false);
  const [changeSection, setChangeSection] = useState(false);
  const [changeSelectSection, setChangeSelectSection] = useState(0);
  const [remarks, setRemarks] = useState('');
  const [list,setList] = useState([]);
  const canCreate = Boolean(reservation_at);
  
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const test = query.get('test')
  const handleCreateOpen = (uuid) => {
    setTopic('');
    setRemarks('');
    setReservation_at(null);
    setLimited_at(null);
    setStart_at(null);
    setUuid(null);
    setCreatedOpen(true);
  }
  const handleReservationAtChange = (newValue) => {
    setReservation_at(newValue);

    if (!limited_at && newValue) {
        setLimited_at(dayjs(newValue).add(2, 'week'));
    }
  }
  
    useEffect(()=>{
        if(changeSelectSection && typeof(changeSelectSection) == 'number'){
            let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/calling/getList?tenpo=` + changeSelectSection;
            axios.get(url,{ headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {

            if(response.data && response.data != 'error'){
                setList(response.data)
            }
            });
        }
      },[changeSelectSection])
  const handleCreate = (uuid) => {
    if (!canCreate) {
        return;
    }

    const createLimitedAt = limited_at || dayjs(reservation_at).add(2, 'week');
    setLimited_at(createLimitedAt);

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/calling/getUuid`;
    // let url = `http://localhost:5000/api/v1/calling/getUuid`;
    axios.post(url,{
        reservation_at:reservation_at,
        topic:topic,
        limited_at:createLimitedAt,
        remarks:remarks
    },{ headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
    //   setuser(response.data)
    console.log(response.data,"ユーザーデータ")
    if(response.data && response.data != 'error'){
        setUuid(response.data)
        let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/calling/getList`;
        // let url = 'http://localhost:5000/api/v1/calling/getList'

        axios.get(url,{ headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
        //   setuser(response.data)
        console.log(response.data,"ユーザーデータ")
        if(response.data && response.data != 'error'){
            setList(response.data)
        }
        });
    }
    });
  }
  
  const handleCloseCreate = (uuid) => {    
    setTopic('');
    setRemarks('');
    setReservation_at(null);
    setLimited_at(null);
    setStart_at(null);
    setUuid(null);
    setconnectOpen(false)
    setOpen(false)
    setCreatedOpen(false)
  }
  const handleOpen = (value,connect) => {
    
    setId(value.id);
    setUuid(value.uuid);
    console.log(value)
    setTopic(value.topic);
    setRemarks(value.remarks);
    setReservation_at(value.reservation_at ? dayjs(value.reservation_at) : null);
    setLimited_at(value.limited_at ? dayjs(value.limited_at) : null);
    // if(value.start_at){
    //     var start_at = dayjs(value.start_at)
    //     console.log(start_at)
    //     setStart_at(dayjs(start_at).format('YYYY年MM月DD日 HH時mm分'));
    // }
    console.log(value.uuid)
    setOpen(true);
    setConnect(connect)
  };
  const dateFormat = (e) => {
    return e.replace('T',' ').replace('.000Z','').slice( 0, -3 )
  }
  const handleClose = () => {
    console.log(topic,reservation_at,limited_at,start_at)
    setTopic('');
    setRemarks('');
    setReservation_at(null);
    setLimited_at(null);
    setStart_at(null);
    setUuid('');
    setconnectOpen(false)
    setConnect(false)
    setOpen(false)
  };
  const authentication = useContext(Authentication);

  useEffect(()=>{
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/calling/getList`;
    // let url = 'http://localhost:5000/api/v1/calling/getList'

    axios.get(url,{ headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
    //   setuser(response.data)
    console.log(response.data,"ユーザーデータ")
    if(response.data && response.data != 'error'){
        setList(response.data)
    }
    });
  },[])
    const url = (e) => {
        console.log(e)
        e.target.select()
        navigator.clipboard.writeText(e.target.value);

        setTooltipOpen(e.target.name);
        tooltipdelete()
    }
    const tooltipdelete = () => {
        setTimeout(() => {
            setTooltipOpen('');
        }, 1000)
    }
    
    const updateUuid = () => {
        let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/calling/updateCall`;
        // let url = 'http://localhost:5000/api/v1/calling/getUuid'
        let obj = {
            id:id,
            uuid:uuid,
            reservation_at:reservation_at,
            topic:topic,
            limited_at:limited_at,
            start_at:start_at,
            remarks:remarks
        }
        Object.keys(obj).forEach(key => {
            if (!obj[key]) {
                delete obj[key];
            }
        });
        axios.post(url, obj,{ headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
        //   setuser(response.data)
        console.log(response.data,"ユーザーデータ")
        if(response.data && response.data != 'error'){
            setUuid(response.data)
            setconnectOpen(false)
            setConnect(false)
            setOpen(false)
            let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/calling/getList`;
            // let url = 'http://localhost:5000/api/v1/calling/getList'

            axios.get(url,{ headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
            //   setuser(response.data)
            console.log(response.data,"ユーザーデータ")
            if(response.data && response.data != 'error'){
                setList(response.data)
            }
            });
        }
        });
    }
  return (
    <div className="App" id="content">
        <Item style={{margin:'0 20px 20px 20px',display:'flex',justifyContent:'space-between'}}>
            <Box>
                {
                // test == 1 ? 
                !changeSection ? 
                <Button variant="contained" onClick={() => setChangeSection(true)}>表示店舗切替</Button>
                :
                <div>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-simple-select-label">表示店舗</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={changeSelectSection}
                    label="表示店舗"
                    onChange={(e)=>{setChangeSelectSection(e.target.value)}}
                >
                    <MenuItem value={1}>番町店</MenuItem>
                    <MenuItem value={2}>レインボーロード店</MenuItem>
                    <MenuItem value={3}>高松駅前店</MenuItem>
                    <MenuItem value={4}>高松東店</MenuItem>
                    <MenuItem value={6}>高松中央公園店</MenuItem>
                    <MenuItem value={17}>本社サンフラワー店</MenuItem>
                    <MenuItem value={47}>中央通り店</MenuItem>
                    <MenuItem value={62}>SS課</MenuItem>
                    <MenuItem value={67}>DS課</MenuItem>
                </Select>
                </FormControl>
                </div>
                    // :
                    // ""
                }
            </Box>
            <Box>
                <Button variant="contained" onClick={() => handleCreateOpen()}>新規作成</Button>
            </Box>
        </Item>
        <div style={{margin:'20px'}}>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell style={{width:'10px',padding:'auto 0'}}>接続</TableCell>
                    <TableCell style={{width:'10px'}}>編集</TableCell>
                    <TableCell style={{width:'300px'}}>タイトル</TableCell>
                    <TableCell style={{width:'300px'}}>備考</TableCell>
                    <TableCell style={{width:'120px'}}>作成日時</TableCell>
                    <TableCell style={{width:'120px'}}>予約日時</TableCell>
                    <TableCell style={{width:'120px'}}>有効期限</TableCell>
                    <TableCell style={{width:'60px'}}>作成</TableCell>
                    {/* <TableCell>開始時間</TableCell>
                    <TableCell>終了時間</TableCell> */}
                </TableRow>
                </TableHead>
                <TableBody>
                {list.map((row) => (
                    <TableRow key={row.id}>
                    <TableCell>
                        <VideoCall onClick={() => handleOpen(row,true)} />
                    </TableCell>
                    <TableCell>
                        <EditButton onClick={() => handleOpen(row,false)} />
                    </TableCell>
                    <TableCell>{row.topic}</TableCell>
                    <TableCell>{row.remarks}</TableCell>
                    <TableCell>{row.created_at ? dateFormat(row.created_at) : '-'}</TableCell>
                    <TableCell>{row.reservation_at ?dateFormat(row.reservation_at) : '-'}</TableCell>
                    <TableCell>{row.limited_at ? dateFormat(row.limited_at) : '-'}</TableCell>
                    <TableCell>{row.created_user_name}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
            {
                !connect ? 
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                    <div style={{textAlign:'center',marginBottom:'20px'}}>
                        <h2 style={{marginTop:'0'}}>編集</h2>    
                    </div>
                    <Grid container spacing={2}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>タイトル</p></Grid>
                        <Grid item xs={8}><TextField style={{maxWidth:'259px',width:'100%'}} value={topic} onChange={(e) => setTopic(e.target.value)} variant="outlined" label="タイトル" /></Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>予約日</p></Grid>
                        <Grid item xs={8}>
                            <LocalizationProvider 
                                dateAdapter={AdapterDayjs} 
                                adapterLocale={jaJP}
                                dateFormats={{ monthAndYear: 'YYYY年 MM月' }}
                                localeText={{
                                    previousMonth: '前月を表示',
                                    nextMonth: '次月を表示',
                                }}
                            >
                                {/* <Container components={['DateTimePicker']} style={{width:'100%'}}> */}
                                    <DateTimePicker
                                    label="予約日"
                                    ampm={false}
                                    hours={24}
                                    timezone={'Asia/Tokyo'}
                                    format="YYYY年MM月DD日 HH時mm分"
                                    value={reservation_at}
                                    onChange={(newValue) => handleReservationAtChange(newValue)}
                                    />
                                {/* </Container> */}
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>有効期限</p></Grid>
                        <Grid item xs={8}>
                            <LocalizationProvider 
                                dateAdapter={AdapterDayjs} 
                                adapterLocale={jaJP}
                                dateFormats={{ monthAndYear: 'YYYY年 MM月' }}
                                localeText={{
                                    previousMonth: '前月を表示',
                                    nextMonth: '次月を表示',
                                }}
                            >
                                    <DateTimePicker
                                    style={{maxWidth:'223px',width:'100%'}}
                                    label="有効期限"
                                    ampm={false}
                                    hours={24}
                                    timezone={'Asia/Tokyo'}
                                    format="YYYY年MM月DD日 HH時mm分"
                                    value={limited_at}
                                    onChange={(newValue) => setLimited_at(newValue)}
                                    />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>備考</p></Grid>
                        <Grid item xs={8}>
                            <TextField
                            label="備考"
                            multiline
                            rows={4}
                            variant="outlined"
                            fullWidth
                            value={remarks}
                            onChange={(e)=>setRemarks(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Box display="flex" justifyContent="space-between">
                        <Button variant="contained" style={{margin:'20px auto',backgroundColor:"#EEE",color:"#2c2c2c"}} onClick={()=>handleClose()}>閉じる</Button>
                        <Button variant="contained" style={{margin:'20px auto'}} onClick={()=>updateUuid()}>保存</Button>
                    </Box>
                </Box>
                </Modal>
                :
                
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                <div style={{maxWidth:'940px',margin:'0 auto',textAlign:'center'}}>
                    <Button variant="contained" target="_blank" href={"https://gl-communication.azurewebsites.net/Send/"+uuid + "?openExternalBrowser=1"}>ビデオ通話開始</Button><br/>
                    <TextField style={{width:'100%'}} hiddenLabel variant="standard" size="small" name="sendform" InputProps={{readOnly: true}} defaultValue={'https://gl-communication.azurewebsites.net/Reception/'+uuid + "?openExternalBrowser=1"} onClick={(e) => url(e)}/>
                        <Tooltip title="コピーしました！" open={tooltipOpen === "sendform" ? true : false}>
                            <div></div>
                        </Tooltip>
                </div>
                
                </Box>
                </Modal>
            }
        </div>
        
        <Modal 
            open={createdOpen}
            onClose={handleCloseCreate}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
        <Box sx={style}>
        <div style={{textAlign:'center',marginBottom:'20px'}}>
            <h2 style={{marginTop:'0'}}>新規作成</h2>    
        </div>
        {uuid ?
        "" : 
        <Grid container spacing={2}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>タイトル</p></Grid>
                        <Grid item xs={8}><TextField style={{maxWidth:'259px',width:'100%'}} value={topic} onChange={(e) => setTopic(e.target.value)} variant="outlined" label="タイトル" /></Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>予約日</p></Grid>
                        <Grid item xs={8}>
                            <LocalizationProvider 
                                dateAdapter={AdapterDayjs} 
                                adapterLocale={jaJP}
                                dateFormats={{ monthAndYear: 'YYYY年 MM月' }}
                                localeText={{
                                    previousMonth: '前月を表示',
                                    nextMonth: '次月を表示',
                                }}
                            >
                                {/* <Container components={['DateTimePicker']} style={{width:'100%'}}> */}
                                    <DateTimePicker
                                    label="予約日"
                                    ampm={false}
                                    hours={24}
                                    timezone={'Asia/Tokyo'}
                                    format="YYYY年MM月DD日 HH時mm分"
                                    value={reservation_at}
                                    onChange={(newValue) => handleReservationAtChange(newValue)}
                                    />
                                {/* </Container> */}
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>有効期限</p></Grid>
                        <Grid item xs={8}>
                            <LocalizationProvider 
                                dateAdapter={AdapterDayjs} 
                                adapterLocale={jaJP}
                                dateFormats={{ monthAndYear: 'YYYY年 MM月' }}
                                localeText={{
                                    previousMonth: '前月を表示',
                                    nextMonth: '次月を表示',
                                }}
                            >
                                {/* <Container components={['DateTimePicker']} style={{width:'100%'}}> */}
                                    <DateTimePicker
                                    style={{maxWidth:'223px',width:'100%'}}
                                    label="有効期限"
                                    ampm={false}
                                    hours={24}
                                    timezone={'Asia/Tokyo'}
                                    format="YYYY年MM月DD日 HH時mm分"
                                    value={limited_at}
                                    onChange={(newValue) => setLimited_at(newValue)}
                                    />
                                {/* </Container> */}
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={3}><p>備考</p></Grid>
                        <Grid item xs={8}>
                        <TextField
                            label="備考"
                            multiline
                            rows={4}
                            variant="outlined"
                            fullWidth
                            value={remarks}
                            onChange={(e)=>setRemarks(e.target.value)}
                            />
                        </Grid>
                    </Grid>
            }
            {uuid ? 
            
        <Grid container spacing={2}>
        <div style={{maxWidth:'940px',margin:'0 auto 10px auto',textAlign:"center"}}> 
        <Button style={{margin:'15px 0'}} variant="contained" target="_blank" href={"https://gl-communication.azurewebsites.net/Send/"+uuid}>ビデオ通話開始</Button><br/>
        <TextField style={{width:'100%'}} hiddenLabel variant="standard" size="small" name="sendform" InputProps={{readOnly: true}} defaultValue={'https://gl-communication.azurewebsites.net/Reception/'+uuid} onClick={(e) => url(e)}/>
            <Tooltip title="コピーしました！" open={tooltipOpen === "sendform" ? true : false}>
                <div></div>
            </Tooltip>
        </div>
        </Grid>
            :
                <div style={{textAlign:'center',marginTop:'20px'}}><Button variant="contained" disabled={!canCreate} onClick={(e) => handleCreate(e)}>新規作成</Button></div>
            }
                </Box>
                </Modal>
        
      <style jsx="true">{
        `
       
        body {
          color: #292f33;
          font-family: 'Lucida Grande','Hiragino Kaku Gothic ProN','ヒラギノ角ゴ ProN W3',Meiryo,メイリオ, sans-serif;
        }
        .top_box{
          text-align: left;
          padding-bottom:20px;
        }
        
        .container {
          padding: 0px 20px;
        }
        
        .news_table{
          background-color:#fff;
          paddnig: 15px !important;
        }

        .news_container{
          background-color:#fff;
          paddnig: 15px !important;
        }
        `
      }
      </style>
    </div>
);
}


export default ReservationCall;
